import React, { useEffect, useRef, useState } from 'react';
import { useTranslation, withTranslation, WithTranslation } from 'react-i18next';

// TODO: rewrite without Semantic UI and jQuery

declare const $: any;

export type LegacyCustomSelectFieldParams = {
    id: string;
    input: any;
    value: string;
    touched: boolean;
    error: any;
    meta: any;
    label: string;
    labelKey: string;
    promptKey: string;
    required?: boolean;
    allowAdditions?: boolean;
    onChangeValue(value: string): void;
    apiSettings: any;
};

// eslint-disable-next-line @typescript-eslint/naming-convention -- TODO: rewrite as a functional component
class _LegacyCustomSelectField extends React.Component<LegacyCustomSelectFieldParams & WithTranslation, any> {
    div: HTMLElement | null = null;

    componentDidMount() {
        const { allowAdditions = false, input, onChangeValue, apiSettings } = this.props;
        if (this.div) {
            // Notice that action and onChange have text and value parameters reversed.
            // This is not a typo on our end.
            $(this.div).dropdown({
                allowReselection: true,
                allowAdditions,
                onChange: (value: string /*, text, $elem*/) => onChangeValue(value),
                apiSettings,
            });

            $(this.div).dropdown('set selected', input.value);
        }
    }

    componentDidUpdate(oldProps: LegacyCustomSelectFieldParams) {
        const { value } = this.props.input;
        if (value !== oldProps.input.value) {
            $(this.div).dropdown('set selected', value);
        }
    }

    setRef = (e: HTMLDivElement) => {
        this.div = e;
    };

    render() {
        const { id, required, label, labelKey, promptKey, input, touched, error, meta, t } = this.props;
        return (
            <div className={ required ? 'required field' : 'field' }>
                { (label || labelKey) &&
                    <label htmlFor={ id }>{ label || t(labelKey) }</label>
                }
                <div className="ui search selection dropdown" ref={ this.setRef }>
                    <input type="hidden" id={ id } { ...input }/>
                    <i className="dropdown icon"></i>
                    <div className="default text">{ t(promptKey) }</div>
                    <div className="menu"></div>
                </div>
                { touched && error && <div className="error">{ meta.error }</div> }
            </div>
        );
    }
}

export const LegacyCustomSelectField = withTranslation()(_LegacyCustomSelectField as any);


export type Props = {
    id: string;
    value: string;
    label?: string;
    labelKey?: string;
    promptKey: string;
    required?: boolean;
    allowAdditions?: boolean;
    onChange(value: string): void;
    apiSettings: any;
};

export const CustomSelectField = ({
    id,
    value,
    label,
    labelKey,
    promptKey,
    required = false,
    allowAdditions = false,
    onChange,
    apiSettings,
}: Props) => {
    const { t } = useTranslation();

    const divRef = useRef<HTMLDivElement | null>(null);

    const [ , setInternalValue ] = useState(value);

    // Initial setup for the drop down component
    useEffect(() => {
        const div = divRef.current;
        if (!div) return;

        // Notice that action and onChange have text and value parameters reversed.
        // This is not a typo on our end.
        $(div).dropdown({
            allowReselection: true,
            allowAdditions,
            onChange: (value: string /*, text, $elem*/) => onChange(value),
            apiSettings,
        });

        // HACK: use the setter, which doesn't change, to access the initial value. i.e.
        // so we don't trigger a recomputation for this useEffect when the value changes.
        setInternalValue(v => {
            $(div).dropdown('set selected', v);
            return v;
        });
    }, [ divRef, allowAdditions, onChange, apiSettings, setInternalValue ]);

    // Update the UI when the select value changes
    useEffect(() => {
        const div = divRef.current;
        if (div) {
            $(div).dropdown('set selected', value);
        }
    }, [ divRef, value ]);


    return (
        <div className={ required ? 'required field' : 'field' }>
            { (label || labelKey) &&
                <label htmlFor={ id }>
                    { label || t(labelKey!) }
                </label>
            }
            <div
                className="ui search selection dropdown"
                ref={ divRef }
            >
                <input
                    type="hidden"
                    id={ id }
                    value={ value }
                    onChange={ () => {} }
                />
                <i className="dropdown icon"/>
                <div className="default text">
                    { t(promptKey) }
                </div>
                <div className="menu"/>
            </div>
        </div>
    );
};
